module.exports = __webpack_public_path__ + "img/thumbnail.30322d80.png";